import {
  getFindVenueOverviewVersionQueryKey,
  useUpdateVenueOverviewVersion,
} from '@api';
import { useInvalidateQuery, useNotification } from '@common';
import { AxiosError } from 'axios';
import { BusinessSeatsFormDataType } from '../useVenueBusinessSeatsFormSchema';

const TRANS_PATH = 'NOTIFICATIONS.UPDATE_VENUE_BUSINESS_SEATS';

type UseUpdateVenueBusinessSeatsReturnType = {
  updateVenueBusinessSeats: (data: BusinessSeatsFormDataType) => Promise<void>;
};

type UseUpdateVenueBusinessSeatsPropsType = {
  venueId: string;
  overviewVersion: string;
  onClose: () => void;
};

export const useUpdateVenueBusinessSeats = ({
  venueId,
  overviewVersion,
  onClose,
}: UseUpdateVenueBusinessSeatsPropsType): UseUpdateVenueBusinessSeatsReturnType => {
  const { mutateAsync } = useUpdateVenueOverviewVersion();
  const { showSuccess, showError } = useNotification();

  const { invalidateQuery } = useInvalidateQuery(
    getFindVenueOverviewVersionQueryKey(venueId, overviewVersion)
  );

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH}.SUCCESS.TITLE`,
      message: `${TRANS_PATH}.SUCCESS.MESSAGE`,
    });
    invalidateQuery();
    onClose();
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH}.ERROR.TITLE`,
      message: `${TRANS_PATH}.ERROR.MESSAGE`,
      error,
    });
  };

  const updateVenueBusinessSeats = async (data: BusinessSeatsFormDataType): Promise<void> => {
    await mutateAsync(
      {
        venueId,
        overviewVersion,
        data: { businessSeats: data },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { updateVenueBusinessSeats };
};
